<template>
  <iframe width="100%" height="360" frameborder="0" style="border: 0" :src="mapIframeSrc" allowfullscreen />
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const i18n = useI18n()

const props = defineProps<{
  target: string
  latitude?: number
  longitude?: number
}>()

const branchCoordinate = computed(() => {
  if (!props.latitude || !props.longitude) return ''

  return `${props.latitude},${props.longitude}`
})
const mapIframeSrc = computed(() => {
  if (!props.target) return ''

  const iframeUrl = new URL(`https://www.google.com/maps/embed/v1/place`)
  const searchParams = new URLSearchParams({
    key: config.public.googleMapApiKey,
    q: props.target,
    ...(branchCoordinate.value
      ? {
          center: branchCoordinate.value,
        }
      : {}),
    zoom: '16',
    language: i18n.locale.value,
  })
  iframeUrl.search = searchParams.toString()

  return iframeUrl.href
})
</script>

<style lang="scss" scoped></style>
